<template lang="pug">
  .chip
    span.text-ellipsis {{ author.name }}
    a.btn.btn-clear(@click="$emit('remove', author)")
</template>

<script>
export default {
  props: { author: { type: Object, required: true } },
}
</script>
